export default "__VITE_ASSET__Dnw2fWfJ__"